import BaseHead from "../templates/BaseHead";
import { getSubdomain } from "../../utils/getSubdomain";
import STUtils from "../../assets/styles/utility.module.scss";
import BoardForm from "../organisms/BoardForm";
import BottomNavigationBar from "../organisms/BottomNavigationBar";

const Board = () => {
  const subdomain = getSubdomain(window.location.hostname);
  return (
    <BaseHead
      title={"ボード"}
      login={true}
      subdomain={subdomain}
      hasBackground
      hasNavigationBar={true}
      hasBackButton={true}
    >
      <div className={STUtils.container_large}>
        <BoardForm />
        <div style={{ marginBottom: "24px" }}>
          <BottomNavigationBar />
        </div>
      </div>
    </BaseHead>
  );
};

export default Board;
